import { Stack } from "@mantine/core"
import { BlurredOverlayWithModal } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { SETTINGS_SCOPE } from "@tfg/types/constants/communication-studio.constant"
import { LanguagePermissionLevelEnum } from "@tfg/types/endpoints/subscriptionPlan"

import { SUPPORT_EMAIL } from "~/constants/email"
import { ActiveLanguages } from "~/pages/Brand/CommunicationStudio/Languages/components/ActiveLanguages"
import { Translations } from "~/pages/Brand/CommunicationStudio/Languages/components/Translations"
import { useOrganizationSubscriptionPlanPermissions } from "~/pages/Brand/CommunicationStudio/contexts/organizationSubscriptionPlanPermissions/useOrganizationSubscriptionPlanPermissions"

export const Languages = () => {
  const contentWidth = "37.5rem"
  const { t } = useTranslation("communicationStudio")

  const { permissions } = useOrganizationSubscriptionPlanPermissions()
  const isReadOnly =
    permissions?.[SETTINGS_SCOPE.LANGUAGES]?.level ===
    LanguagePermissionLevelEnum.READONLY

  return (
    <Stack
      mih="60vh"
      gap="xl"
      mb={50}
      pos="relative"
      style={{
        "--mantine-scale": 1,
      }}
    >
      {isReadOnly ? (
        <BlurredOverlayWithModal
          title={t("lockedFeatureOverlay.languages.title")}
          message={t("lockedFeatureOverlay.languages.message")}
          buttonText={t("lockedFeatureOverlay.languages.buttonText")}
          onButtonClick={() => {
            window.open(
              `mailto:${SUPPORT_EMAIL}?subject=Upgrade%20to%20PRO%20plan`,
              "_blank"
            )
          }}
        />
      ) : (
        <>
          <ActiveLanguages contentWidth={contentWidth} />
          <Translations />
        </>
      )}
    </Stack>
  )
}
